var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.$style.burger, _vm.pageIsMenu && _vm.$style.close],on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},_vm._l((2),function(i){return _c('div',{key:i,class:[_vm.$style.line, _vm.$style[`line${i}`]]})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }